import {lazy} from 'react';
import GenericFallbackSuspense from '../ui/GenericFallback/GenericFallbackSuspense';

const NewCollectionOverlayBody = lazy(() => import('./NewCollectionOverlayBody'/* webpackChunkName: 'NewCollectionOverlayBody' */));

export default function NewCollectionOverlayBodyLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <NewCollectionOverlayBody />
    </GenericFallbackSuspense>
  );
}
